/**
 * EmailDestinatario
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {EmailDestinatarioCollection} from '@/model/collection/EmailDestinatarioCollection'

/* TODO: review generated class */
export class EmailDestinatario extends Resource {
  idEmailDestinatarioPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  cpfCnpj: string | null = null
  email: string | null = null

  get $id() {
    return this.idEmailDestinatarioPk
  }
  set $id(val) {
    this.idEmailDestinatarioPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of EmailDestinatario
   */
  async getEmailDestinatario(id: number) {
    return await Request.get(`/admin/email-destinatario/${id}`)
      .name('getEmailDestinatario')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of EmailDestinatario
   */
  static async listEmailDestinatario(params: any) {
    return await Request.get(`/admin/email-destinatario`, {params})
      .name('listEmailDestinatario')
      .as(EmailDestinatarioCollection)
      .getData()
  }

  /**
   * Persists a new instance of EmailDestinatario. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistEmailDestinatario() {
    return await Request.post(`/admin/email-destinatario`, this)
      .name('persistEmailDestinatario')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of EmailDestinatario to use it in a CSV file
   */
  static async listCsvEmailDestinatario(params: any) {
    return await Request.get(`/admin/email-destinatario/csv`, {params})
      .name('listCsvEmailDestinatario')
      .as(EmailDestinatarioCollection)
      .getData()
  }
}
